import { render, staticRenderFns } from "./RegisterRetail.vue?vue&type=template&id=98861e50"
import script from "./RegisterRetail.vue?vue&type=script&lang=js"
export * from "./RegisterRetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports